import { getTimeframeIndexedPath } from '../timeframes/timeframes-form.utils';

export const getStrategyPath = (timeframeIndex: number) => {
  return `${getTimeframeIndexedPath(timeframeIndex)}.strategy` as const;
};

export type StrategyPath = ReturnType<typeof getStrategyPath>;
